import { useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";

let subscriber = null

function subscribe(fn) {
  subscriber = { fn }
}

function unsubscribe() {
  subscriber = null
}

export function alert(config) {
  subscriber.fn(config)
}

export default function Alert() {
  const [config, setConfig] = useState()

  useEffect(() => {
    subscribe(setConfig)
    return () => {
      unsubscribe()
    }
  })

  const handleClose = () => {
    config.onClose && config.onClose()
    setConfig()
  }

  return (
    <Modal isOpen={config}>
      <div className="modal-header d-flex justify-content-center">
        <h3 className="modal-title" id="exampleModalLabel">
          {config?.header}
        </h3>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={handleClose}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <ModalBody>
        <div className="d-flex align-items-center justify-content-center">
          {!!config?.icon && (<i className={`bi ${config?.icon} mr-3`} style={{ fontSize: '2rem' }} />)}
          <span>{config?.text}</span>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button type="button" color="primary" onClick={handleClose}>Ok</Button>
      </ModalFooter>
    </Modal>
  )
}